export { default } from './RugAward';
